import { useQuery } from "react-query"
import { getJobProposals, getProposalsReportData } from "./proposalsReportApi"

export const useProposalsReportDataQuery = (startDate?: string, endDate?: string) => {
  return useQuery(['proposalsReport', startDate, endDate], {
    queryFn: () => getProposalsReportData(startDate, endDate),
    refetchOnWindowFocus: false
  })
}

export const useGetJobProposalsQuery = (jobId?: number) => {
  return useQuery(['proposal', jobId], {
    queryFn: () => getJobProposals(jobId!),
    refetchOnWindowFocus: false,
    enabled: !!jobId
  })
}